import React, { Component } from 'react';
import TextInput from '../TextInput';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  FormGroup,
  FormText
} from 'reactstrap';

class PromoCodeInput extends Component {
  constructor(){
    super();

    this.state = {
      value:''
    }
  }

  componentWillMount(){
    const { defaultValue, value } = this.props;

    if(defaultValue){
      this.setState({value:defaultValue});
    } else if(value){
      this.setState({value:value});
    }
  }

  handleChange(event){

    this.setState({value:event.target.value.toUpperCase().replace(/\s/gi, "").replace(/[^0-9a-z]/gi, "") })
  }

  render(){
    const { label, name, warning, placeholder } = this.props;
    const { value } = this.state;

    return (
      <FormGroup>
        {label.length > 0 && (
          <Label>{label}</Label>
        )}
        <Input 
          name={name}
          value={value}
          onChange={(e) => this.handleChange(e)}
          maxLength={20}
          placeholder={placeholder}
        />
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
      </FormGroup>
    )
  }
}

PromoCodeInput.defaultProps = {
  placeholder:'',
  warning:'',
  label:''
};

export default PromoCodeInput;


// WEBPACK FOOTER //
// ./src/shared/components/PromoCodeInput/index.js